import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
// import logo from './logo.svg'
import styled from 'styled-components'
// import Link from 'components/Link'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { CasesWorldMap } from 'components/CasesWorldMap'
import '../globals.scss'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {/* add your content here */}
      <CasesWorldMap title={properties?.title} toggleNameLeft={properties?.toggleNameLeft} toggleNameRight={properties?.toggleNameRight} dwChartIdLeft={properties?.dwChartIdLeft} dwChartIdRight={properties?.dwChartIdRight}></CasesWorldMap>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ tenant?: string }>`
  width: 100%;
  max-width: 842px;
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-family: var(--font-sans-serif);
  margin-left: auto;
  margin-right: auto;
  /* color: var(--brandblue-main); */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
  /* @media (max-width: 599px) {
    margin-left: 1em;
    margin-right: 1em;
  } */

  iframe {
    width: 100%;
    border: none !important;
    overflow: hidden;
    min-height: 250px;
  }

  .App-header {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
    .tenant {
      ${(props) => (props.tenant ? `color: var(--tenant-${props.tenant})` : '')}
    }
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
export default MainComponent
